import React, { useState } from "react";
import { DataGrid, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { AdminPanelSettings } from "@mui/icons-material";
import withDialogState from "@/hoc/withDialogState"; // Import the HOC
import SelectWeekendPolicy from "@/pages/attendanceManagement/weekendPolicy/SelectWeekendPolicy";
import { useGetWeekendPolicyQuery } from "@/api/services/attendanceManagement/weekendPolicy/WeekendPolicy";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";
// import NewDatatable from "@/components/dataTableComponents/NewDatatable";

// Wrap SelectWeekendPolicy with the HOC
const EnhancedSelectWeekendPolicy = withDialogState(SelectWeekendPolicy);
// DataGrid component
const WeekendDataGrid = () => {

  const [open, setOpen] = useState(false); 
  const [selectedRow, setSelectedRow] = useState(null);
  const { data, isLoading, error, refetch } = useGetWeekendPolicyQuery();
  const weekendPolicyData = data?.data || [];

  // State for managing dialog
  // const [open, setOpen] = useState(false);
 

  // Function to handle edit click
  const handleEditClick = (row) => {
    setSelectedRow(row); // Set selected row data
    setOpen(true); // Open the dialog
  };


  // Define columns
  const columns = [
    // {
    //   field: "S.No",
    //   headerName: "S.No",
    //   flex: 1,
    //   renderCell: (params) => {
    //     return (
    //       <Box display="flex" alignItems={"center"} height={"100%"}>
    //         {/* {params.api.getRowIndex(params.id) + 1} */}
    //         {params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}
    //       </Box>
    //     );
    //   },
    // },
    {
      field: "month",
      headerName: "Month",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems={"center"} height={"100%"}>
            {moment(params.row.month, "MM-YYYY").format("MMMM YYYY")}
          </Box>
        );
      },
    },
    {
      tabIndex: 0,
      field: "satDate",
      headerName: "Saturday",
      flex: 1,
      renderCell: (params) => {
        const { week } = params.row;
        return (
          <Box>
            {week?.map((weekend, index) => (
              <Box
                key={`${params.row.id}_${weekend.weekName}_${index}`}
                mb={1}
                display={`flex`}
              >
                {weekend.satDate !== null ? (
                  <>
                    <Typography component="strong" fontWeight={"bold"}>
                      {weekend.weekName}:
                    </Typography>
                    <Typography
                      variant="body2"
                      display={"inline"}
                      alignItems={"center"}
                    >
                      {weekend.satStatus} (
                      {moment(weekend.satDate).format("DD MMM YYYY")})
                    </Typography>
                  </>) : ""}
              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      field: "sunDate",
      headerName: "Sunday",
      flex: 1,
      renderCell: (params) => {
        const { week } = params.row;
        return (
          <Box>
            {week?.map((weekend, index) => (
              <Box
                key={`${params.row.id}_${weekend.weekName}_${index}`}
                mb={1}
                display="flex"
                alignItems="center"
              >
                {weekend.sunDate !== null ? (
                  <>
                    <Typography component="strong" fontWeight={"bold"}>
                      {weekend.weekName}:
                    </Typography>
                    <Typography
                      variant="body2"
                      display={"inline"}
                      alignItems={"center"}
                    >
                      {weekend.sunStatus} (
                      {moment(weekend.sunDate).format("DD MMM YYYY")})
                    </Typography>
                  </>) : ""}

              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <Box display="flex" alignItems={"center"} height={"100%"}>
              {/* <IconButton
                onClick={(e) => onButtonClick(e, params.row)}
                color="#A5A1A1"
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton> */}
              <IconButton color="#A5A1A1" aria-label="edit" onClick={() => handleEditClick(params.row)}>
                <EditIcon />
              </IconButton>
            </Box>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ width: "100%", p: 0 }}>

      <CommonDataTable
        rows={weekendPolicyData}
        columns={columns}
      />

      <EnhancedSelectWeekendPolicy
        open={open}
        setOpen={setOpen}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        refetch={refetch}
      />

    </Box>
  );
};

// Wrap the WeekendPolicy component with the same HOC to inject the state management props
export default withDialogState(WeekendDataGrid);
